'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.promotions = void 0;
var tslib_1 = require("tslib");
var adapter_1 = require("../adapter");
var session_1 = require("../session/session");
var Promotions = /** @class */ (function () {
    function Promotions() {
    }
    /**
     * Filter promotions
     */
    Promotions.prototype.filter = function (type, lang, mobile, lobbyFilter, userName) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var user, serverPromos;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        user = session_1.session.getUser();
                        return [4 /*yield*/, adapter_1.adapter.promotions.filter({
                                lang: lang,
                                type: type,
                                userName: userName || (user ? user.userName : undefined),
                                lobbyFilter: lobbyFilter,
                                isDevice: mobile,
                            })];
                    case 1:
                        serverPromos = _a.sent();
                        return [2 /*return*/, (serverPromos
                                .map(function (serverPromo) {
                                var _a, _b;
                                return (tslib_1.__assign(tslib_1.__assign({}, serverPromo), { image: serverPromo.image[lang], title: serverPromo.title[lang], subtitle: serverPromo.subtitle[lang], background: serverPromo.background[lang], mobileBackground: (serverPromo.mobileBackground || {})[lang], link: serverPromo.link[lang], markdown: serverPromo.markdown[lang], values: tslib_1.__assign(tslib_1.__assign({}, (serverPromo.values[lang] || {})), { cta: (((_a = serverPromo.values[lang]) === null || _a === void 0 ? void 0 : _a.cta) || []).map(function (cta) { return (tslib_1.__assign(tslib_1.__assign({}, cta), { link: cta[mobile ? 'mobile' : 'desktop'] })); }), tnc: ((_b = serverPromo.values[lang]) === null || _b === void 0 ? void 0 : _b.tnc) || '' }), icon: (serverPromo.icon || {})[lang], expiry: serverPromo.expiry }));
                            })
                                // TODO: remove sorting when done in backend
                                .sort(function (a, b) { return a.position - b.position; }))];
                }
            });
        });
    };
    /**
     * Opt in to promotion
     */
    Promotions.prototype.optIn = function (name, lang, cta, userId) {
        var params = { name: name, lang: lang, cta: cta, userId: userId };
        return adapter_1.adapter.promotions.optIn(params);
    };
    /**
     * Get promotions by category id
     */
    Promotions.prototype.getByCatId = function (catId) {
        var params = { catId: catId };
        return adapter_1.adapter.promotions.getByCatId(params);
    };
    /**
     * Get promotions categories
     */
    Promotions.prototype.getCategories = function (lang) {
        return (adapter_1.adapter.promotions
            .getCategories({ lang: lang })
            // TODO: remove sorting when done in backend
            .then(function (categories) {
            return categories.sort(function (a, b) { return a.position - b.position; });
        }));
    };
    return Promotions;
}());
exports.promotions = new Promotions();
